export default __webpack_public_path__ + "static/favicon-3cd6f3d8790ad39f17b2b7257c3a78d3.ico";